/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 */

import { useAgency } from '@pages/authenticated/agency-pages/AgenciesContext';
import { isSoloBrokerAgency } from '@/shared/utils/agency-type';

/**
 * Whether the active agency is a solo-broker account.
 *
 * Solo brokers are the only user in their agency: they hold every permission,
 * cannot invite members, and are implicitly the broker on every record — so any
 * "responsible broker" affordance (select, column, filter, card) has nothing to
 * choose between and is hidden.
 *
 * @returns True when the active agency is of type `solo_broker`.
 */
export function useIsSoloBroker(): boolean {
  const type = useAgency((state) => state.agency?.type);
  return isSoloBrokerAgency(type);
}
